/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum VehicleType {
  CAR = 0,
  BIKE = 1,
  LORRY = 2,
  TRUCK = 3,
}

export namespace VehicleType {
  export function values() {
    return Object.keys(VehicleType).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
